<template>
  <Grid class="grid-gutter-md">
    <template v-if="hasMealPlan || editMealPlan">
      <Col6>
        <PlanType :name="`${formNamespace}type`" :disabled="disablePlanType" />
      </Col6>

      <Col6>
        <PlanName :name="`${formNamespace}name`" :disabled="disablePlanName" />
      </Col6>

      <template v-if="isITC">
        <slot name="itc" />
      </template>

      <template v-if="mealPlanType === MEALPLAN_TYPES.ATRIUM">
        <slot name="atrium" />
      </template>

      <template v-if="mealPlanType === MEALPLAN_TYPES.ATRIUM_SSO">
        <slot name="atriumSSO" />
      </template>

      <template v-if="mealPlanType === MEALPLAN_TYPES.HEARTLAND">
        <slot name="touchnet" />
      </template>

      <template v-else-if="isTransact">
        <slot name="transact" />
      </template>

      <template v-if="mealPlanType === MEALPLAN_TYPES.CBORD_DIRECT">
        <slot name="cbordDirect" />
      </template>

      <template v-if="mealPlanType === MEALPLAN_TYPES.CBORD">
        <slot name="cbordWeb" />
      </template>

      <template v-if="!isTouchNet">
        <Col12>
          <Tenders :isDisabled="!editMealPlan" :mealPlanType="mealPlanType" />
        </Col12>
      </template>
      <template v-if="isTransact && showMEQOrMX">
        <Col12>
          <MealExchange />
        </Col12>
      </template>

      <template
        v-if="
          (mealPlanType === MEALPLAN_TYPES.CBORD_DIRECT || mealPlanType === MEALPLAN_TYPES.CBORD) &&
          showMEQOrMX
        "
      >
        <Col12>
          <MealEquivalency />
        </Col12>
        <Col12>
          <MealExchange />
        </Col12>
      </template>
    </template>

    <!-- Only used for site meal plan. This component will never render for station if site config doesn't exist -->
    <template v-else-if="!editMealPlan">
      <Col12>
        {{ t('sites.singleSite.financialConfig.mealPlans.empty') }}
      </Col12>
    </template>
  </Grid>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useMealPlan } from '../composables';
import PlanType from '../fields/plan-type/PlanType.vue';
import PlanName from '../fields/plan-name/PlanName.vue';
import { useFieldValue } from 'vee-validate';
import { computed, provide } from 'vue';
import { ITC_TYPES, MEALPLAN_TYPES, TOUCHNET_TYPES, TRANSACT_TYPES } from '../../enums';
import { storeToRefs } from 'pinia';
import { useFinancialConfigStore } from '../../../../../routes';
import Tenders from '../../tenders/Tenders.vue';
import MealEquivalency from '../fields/meal-equivalency/MealEquivalency.vue';
import MealExchange from '../fields/meal-exchange/MealExchange.vue';

const props = defineProps({
  formNamespace: {
    type: String,
    default: '',
  },
  disablePlanType: {
    type: Boolean,
    default: false,
  },
  disablePlanName: {
    type: Boolean,
    default: false,
  },
  showMEQOrMX: {
    type: Boolean,
    default: true,
  },
});
const { t } = useI18n();

provide('formNamespace', props.formNamespace);

const fConfigStore = useFinancialConfigStore();
const { editMealPlan } = storeToRefs(fConfigStore);

const { hasMealPlan } = useMealPlan();

const mealPlanType = useFieldValue<string>(`${props.formNamespace}type`);

const isITC = computed<boolean>(() => ITC_TYPES.includes(mealPlanType.value));
const isTouchNet = computed<boolean>(() => TOUCHNET_TYPES.includes(mealPlanType.value));
const isTransact = computed<boolean>(() => TRANSACT_TYPES.includes(mealPlanType.value));
</script>
